import { LOCALES } from "../locales";

export default {
  [LOCALES.ITALIAN]: {
    // general product translation
    January: "gennaio",
    February: "febbraio",
    March: "marzo",
    April: "aprile",
    May: "maggio",
    June: "giugno",
    July: "luglio",
    August: "agosto",
    September: "settembre",
    October: "ottobre",
    November: "novembre",
    December: "dicembre",

    class_policy: "Regole della lezione",
    Faq: "FAQs",
    help: "Guida",
    frequently_asked_ques: "Domande frequenti (FAQ)",
    customer_support: "Assistenza clienti",
    user_name: "Nome utente",
    password: "Password",
    email_address: "Indirizzo e-mail",
    // Header Translations
    notification: "Notifica",
    page_loading_aria: "La pagina è in loading",
    state_loading_aria: "Lo Stato è in loading",
    city_loading_aria: "La città è in loading",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Badge generale",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Immagine del certificato",
    certificate_download: "Pulsante per scaricare il certificato",
    prev: "Precedente",
    log_out: "Disconnetti",
    // feature names
    feature_progress: "Progresso",
    feature_stressAndIntonation_title: "Accento e intonazione",
    feature_soundOfEnglish_title: "I suoni dell’inglese",
    feature_vocabularyCenter_title: "Sezione vocabolario",
    feature_grammarCenter_title: "Sezione della Grammatica",
    feature_cultureNotes_title: "Note culturali",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Esercizi personalizzati sui settori industriali",
    feature_newsfeed_title: "Notizie",
    feature_emailTemplates_title: "Modelli di e-mail",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "Accenti e dialetti",
    feature_writingCenter_title: "Sezione della Scrittura",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "Informazioni ",
    legal: "Note legali",
    privacy_policy: "Norme sulla privacy",
    Terms_conditions: "Termini e condizioni",
    //button translations
    button_continue: "Continua",
    button_KnowMore: "Per saperne di più",
    button_BuyNow: "Compra adesso",
    button_Subscribe: "Sono d'accordo",
    button_GetStarted: "Iniziare ",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "Visualizza i dettagli",
    button_ContinueStudying: "Continua",
    button_next: "Successiva",
    button_confirm: "Conferma",
    // cookie policy
    common_cookiesPolicyText1:
      "Learnship utilizza i cookie per garantirvi il miglior servizio possibile. Rimanendo sul sito acconsentite all'",
    common_cookiesPolicyText2: "uso dei cookie",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Benvenuto/a,",
    login_heloo: "Salve di nuovo",
    login_welcome_text: "Cominciamo",
    login_log_in: "Accedi",
    login_errorIncorrectCreds: "Nome utente o password non corretto/a",
    login_errorContactAmin: "Il Suo account non è attivo. Si prega di contattare l'amministratore.",
    login_errorSSOuser: "Deve effettuare l'accesso dal portale di apprendimento dell'azienda.",
    login_forgotPassword: "Ha dimendicato la password?",
    login_resetPasswordTitle: "Reimposta password",
    login_resetSuccess:
      "Le abbiamo inviato una mail contenente un link che le consentirà di reimpostare la Sua password. ",
    login_resetFailure: "L'indirizzo email non è corretto",
    // common translations
    message_errorDefault: "Si è verificato un errore",
    message_successUpdated: "Aggiornamento riuscito",
    message_unknownError: "Unknown error",
    message_unAuthorized: "Sei autorizzato",
    message_passwordUpdated: "Aggiornamento della password riuscito",
    message_profileUpdated: "Aggiornamento del profilo riuscito",
    message_welcomeSubmitted: "Inviati correttamente",
    message_samepasswordError:
      "Si prega di inserire una nuova password. Assicurarsi che non si tratti di una password già utilizzata.",
    SAR: "Seleziona una regione",
    SAL: "Seleziona una località",
    SAT: "Seleziona un argomento",
    link_readmore: "Altre informazioni",
    //--//
    profile_title: "Profilo",
    profile_nameLabel: "Mi chiamo: ",
    profile_countryLabel: "Paese",
    profile_stateLabel: "Stato/Provincia/Regione",
    profile_cityLabel: "Città",
    profile_emailLabel: "Email",
    profile_prefContactLabel: "Metodo di contatto preferito",
    profile_prefSkypeLabel: "ID Skype (Personale)",
    profile_prefMobileLabel: "Numero di cellulare",
    profile_prefLandlineLabel: "Numero di linea fissa",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "Accetto e concordo con i termini e le condizioni",
    profile_continueAria: "Pulsante continua",
    profile_TermsAria: "accetto i termini e le condizioni",
    profile_stateTooltip: "Il Suo fuso orario ci aiuterà a programmare le Sue sessioni online.",
    profile_cityTooltip:
      "Se non vive in nessuna delle città elencate qui sotto, è pregato di selezionare la città più vicina alla Sua.",
    profile_emailTooltip: "Verifichi la Sua email",
    profile_prefTooltip:
      "Tutte le Sue sessioni si svolgeranno nella classe virtuale, anche se Lei ha specificato un metodo di contatto differente nel processo di inserimento delle informazioni iniziali. Le abbiamo chiesto il Suo metodo di contatto preferito solo per uso interno, in modo da poter migliorare continuamente la Sua esperienza di apprendimento.",
    profile_fnamePlaceholder: "Nome",
    profile_lnamePlaceholder: "Cognome",
    profile_countryPlaceholder: "Selezionare un Paese",
    profile_prefContactSelect: "Selezioni la Sua preferenza",
    profile_statePlaceholder: "Selezioni uno Stato",
    profile_cityPlaceholder: "Selezioni una città",
    profile_emailInvalidMessage: "L'indirizzo email non è valido",
    profile_prefContactPlaceholder: "Scelga la Sua preferenza",
    profile_prefSkypePlaceholder: "Skype (Personale)",
    profile_emailVerifiedChip: "Verificato",
    profile_emailVerifyChip: "Verifica",
    profile_emailpopup_head: "Inserire il codice di verifica",
    profile_emailpopup_codePlaceholder: "Code",
    profile_emailpopup_resendText: "Rimanda il codice",
    profile_emailpopup_resendMessage: "Non ha ricevuto il codice?",
    profile_invalidNumber: "Numero non valido",
    profile_prefSkypeAria: "Metodo di contatto preferito: ID Skype (Personale)",
    profile_prefMobileAria: "Metodo di contatto preferito: cellulare",
    profile_prefLandlineAria: "Metodo di contatto preferito: linea fissa",
    profile_emailpopup_incorrectCode: "Codice non valido",
    profile_editLabel: "Modifica il profilo",
    profile_editAria: "Pulsante di modifica",
    profile_mainPasswordPlaceholder: "Inserisca qui la password",
    profile_updateLabel: "Aggiorna",
    profile_welcomeJumbotron: "Ci dica qualcosa di Lei.",
    profile_cancelLabel: "Annulla",
    noAccessl1: "Oops! Non ha il permesso di vedere questa pagina.",
    noAccessl2: "Qui trova il link per tornare indietro alla",
    noAccessl2_1: "homepage",
    noAccessl3: "è pregato di contattare il Suo Amministratore di Learnship se ha bisogno d'aiuto.",
    profile_changepass_changepassHead: "Modifica la password",
    profile_changepass_currentpassword: "Inserisca la password attuale",
    profile_changepass_currentpasswordPlaceholder: "Inserisca la password attuale",
    profile_changepass_newpassword: "Nuova password",
    profile_changepass_newpasswordPlaceholder: "Inserisca la nuova password",
    profile_changepass_confirmnewpassword: "Confermi la nuova password",
    profile_changepass_confirmnewpasswordPlaceholder: "Conferma la nuova password",
    profile_passMustInclude: "La password deve soddisfare i seguenti requisiti:",
    profile_passdontmatch: "Le password non corrispondono",
    profile_incorrectPassword: "Password non corretta",
    profile_passwordSubmit_title: "Inserisca la password",
    profile_changepass_conditionLength: "Tra 8 e 12 caratteri",
    profile_changepass_conditionUppercase: "Almeno una lettera maiuscola",
    profile_changepass_conditionLowercase: "Almeno una lettera minuscola",
    profile_changepass_conditionSpecialCharacters: "Almeno una cifra o uno di questi simboli $!#&@?%*_",
    profile_translationLanguage: "Lingua di traduzione",
    profile_translationLanguagePlaceholder: "Scelga una lingua",
    profile_managerEmailPlaceholder: "Email del gestore",
    profile_managerEmailpopupPlaceholder: "Indirizzo email del Manager",
    // Learner Home Page translations
    learnerhome_survey_header: "Abbiamo bisogno del tuo feedback!",
    learnerhome_survey_line1: "La tua azienda vorrebbe sapere com’è andata la tua esperienza con i nostri servizi. ",
    learnerhome_survey_line2: "Si prega di completare il nostro sondaggio",
    learnerhome_survey_line3: "Il tuo feedback è molto importante ed enormemente apprezzato",
    learnerhome_survey_button1: "Partecipa al sondaggio",
    learnerhome_survey_button2: "Salta il sondaggio",
    active_course: "Attiva il corso",
    admin_header: "Administration",
    get_startedText: "Clicchi su un corso qui in basso per cominciare",
    product_solo_desc:
      "Learnship Solo, il nostro prodotto di e-learning, fornisce agli studenti tutto ciò di cui hanno bisogno per praticare e migliorare le loro abilità nella lingua aziendale che stanno studiando, seguendo e assecondando il loro personale ritmo di apprendimento.",
    product_conversationPractice_desc:
      "Gli studenti possono programmare lezioni individuali con un formatore per fare domande, discutere su una questione specifica o inscenare dei role play. Strumento utile per gli studenti con più esperienza che desiderano affinare le proprie abilità linguistiche.",
    product_sprint_businessSkills_desc:
      "Questo programma di apprendimento misto, di ultima generazione, sviluppa, in tempi record, competenze aziendali specifiche - presentare, negoziare, scrittura aziendale e partecipazione alle riunioni - .",
    product_sprint_levelsProgress_desc:
      "Il nostro  programma di apprendimento misto, di ultima generazione, aiuta il Suo personale a migliorare rapidamente le abilità in lingua inglese, rispettando un quadro standardizzato.",
    product_evolve_relocationLanguage_desc:
      "Il nostro  programma creato per i dipendenti trasferiti aiuta gli studenti a maturare una conoscenza approfondita sia della lingua che delle nuance linguistiche del loro nuovo paese di residenza.",
    product_evolve_culturePowerSkills_desc:
      "Fornisca ai Suoi dipendenti le competenze interculturali chiave di cui hanno bisogno per dare il meglio negli ambienti di lavoro e nei team virtuali globali.",
    product_evolve_cultureFocus_desc:
      "Una formazione specifica sul Paese di destinazione e sull'intelligenza culturale per coloro che desiderano acquisire una comprensione più dettagliata di una regione specifica e dell'ambiente lavorativo di quest'ultima.",
    product_evolve_cultureChange_desc:
      "Questo è il nostro programma principale di formazione aziendale interculturale per i dipendenti che sono stati trasferiti. Fornisce agli studenti una comprensione approfondita di ciò che serve per vivere e lavorare in una nuova cultura.",
    product_elevate_businessSkills_desc:
      "Moduli di apprendimento standardizzati, brevi, per studenti che desiderano migliorare nelle specifiche competenze aziendali come per esempio presentazioni, negoziazioni o leadership di un team. Offriamo inoltre corsi specialistici incentrati sui linguaggi dei settori industriali specifici.",
    product_elevate_levelsProgress_desc:
      "Questo corso di lingua aziedale guidato da un formatore aiuta gli studenti a migliorare le abilità scritte e orali secondo un quadro standardizzato.",
    product_coach_languageCoach_desc:
      "Comunichi con sicurezza e chiarezza durante le riunioni, nelle e-mail, nelle trattative e persino parlando dei distributori dell'acqua. Il nostro coaching linguistico individuale e iper-specifico per dirigenti  La aiuterà a padroneggiare gli scenari aziendali più importanti. Svilupperà le Sue capacità di comunicazione orale, scritta, personale anche durante i meeting.",
    product_coach_cultureCoach_desc:
      "Un programma di coaching individuale e iper-focalizzato per dirigenti che cercano di risolvere problemi specifici di comunicazione interculturale.",
    product_solo_business_english:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business English at your own pace.",
    product_solo_business_german:
      "Un programma di apprendimento multilivello e graduale con esercizi online coinvolgenti per perfezionare le tue conoscenze e l'applicazione del tedesco aziendale secondo il tuo ritmo personale.",
    product_solo_business_french:
      "Un programma di apprendimento multilivello e graduale con esercizi online coinvolgenti per perfezionare le tue conoscenze e l'applicazione del francese aziendale secondo il tuo ritmo personale.",
    product_solo_business_spanish:
      "Un programma di apprendimento multilivello e graduale con esercizi online coinvolgenti per perfezionare le tue conoscenze e l'applicazione dello spagnolo aziendale secondo il tuo ritmo personale.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "Questo è il tuo gateway al Dashboard – un interfaccia intuitivo che consente agli amministratori di tracciare l’utilizzo, analizzare I progressi dello studente, ottimizzare I programmi e valutare il ROI.",
    product_elevate_desc: "Elevate Business English è il nostro corso di formazione, online e face-to-face, pensato per coloro che desiderano perfezionare la padronanza linguistica globale, lavorando con un formatore personale.",
    product_lorem_solo_desc:
      "Questo ricco programma multimediale aiuterà i tuoi dipendenti a perfezionare rapidamente le loro competenze in inglese secondo un quadro standardizzato.",
    //feature translations
    feature_cultureNotes_desc:
      "Familiarizzi con le culture di quelle regioni che sono importanti per il Suo lavoro e per la Sua vita professionale.",
    feature_emailTemplates_desc:
      "I modelli di email coprono un'ampia varietà di argomenti aziendali. Selezioni il modello che desidera e lo esporti direttamente nel Suo client di posta elettronica dove può modificarlo.",
    feature_newsFeed_desc:
      "Benvenuti nella nostra rivoluzionaria esperienza di notizie dal mondo! Impari l'inglese attraverso i contenuti e le domande che vengono generati dal vivo dal nostro sistema Learnship.",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "Le risorse per gli esercizi linguistici vengono combinate con articoli specifici dei vari settori industriali e potenziati dall'Intelligenza Artificiale. Scelga un articolo e un argomento di grammatica che vuole praticare. ",
    feature_accentsAndDialects_desc:
      "Esplora la varietà  mondiale dell'inglese attraverso la nostra libreria di esempi di parlato regionali.",
    feature_stressAndIntonation_desc:
      "Renda il Suo inglese più naturale e più facile da comprendere imparando a usare nel modo corretto l'accento, il ritmo e l'intonazione.",
    feature_soundOfEnglish_desc:
      "Migliori le Sue competenze comunicative pronunciando correttamente i suoni dell'inglese.",
    feature_vocabularyCenter_desc:
      "Senza la grammatica, si può comunicare molto poco. Senza il vocabolario non si può comunicare per niente. -  David Wilkins",
    feature_grammarCenter_desc:
      "IL Centro Studi sulla Grammatica La aiuterà ad utilizzare la grammatica correttamente mentre parla e scrive. Il Centro comprende argomenti grammaticali, come le parti della frase, i verbi e le forme dei verbi, le frasi e le proposizioni.",
    feature_globalCommunityTutorials_desc:
      "Migliori le Sue competenze in lingua inglese con questa collezione  in continua crescita di lezioni sviluppate dalla comunità.",
    feature_toeic_desc:
      "Il test TOEIC® è lo strumento più largamente utilizzato dalle multinazionali per valutare la conoscenza dei propri dipendenti in lingua inglese. Il  TOEIC® utilizza materiali scritti autentici e dialoghi per valutare le Sue competenze in inglese aziendale. ",
    feature_toefl_desc:
      "Il TOEFL®, Test di inglese come lingua straniera, viene usato in tutto il mondo per valutare la conoscenza dell'inglese dai college e dalle Università, dalle agenzie governative e dai programmi per assegnare le borse di studio.",
    feature_businessSituations_desc:
      "L'Indice delle Situazioni Aziendali facilita il compito di trovare attività specifiche in modo da concentrarsi sul linguaggio di cui ha bisogno per comunicare in un'ampia varietà di situazioni aziendali. ",
    //carousel block translations
    title_feature: "Caratteristiche",
    we_recommend: "Consigliamo inoltre",
    // session report translations
    SessionReport_sessionReport: "Report sessione",
    SessionReport_sessionDetails: "Dettagli",
    SessionReport_teacherName: "Nome del formatore",
    SessionReport_sessionReview: "Riveda la sessione",
    SessionReport_sessionFeedback: "Feedback sulla sessione",
    SessionReport_sessionMaterials_Assignments: "Materiale e Assegno della sessione",
    SessionReport_instructions: "Istruzioni",
    SessionReport_open: "Aprire",
    SessionReport_invalidSession_Message: "Siamo spiacenti, non ci sono report per questa sessione.",
    SessionReport_rateSession: "Valuti la sessione",
    SessionReport_coachName: "Com'è andata la Sua sessione con",
    SessionRating_sessionDate: "Data della sessione",
    SessionRating_sessionTime: "Ora della sessione",
    SessionRating_sessionDuration: "Durata della Sessione",
    SessionRating_status: "Stato",
    SessionRating_rateYourExperience: "Valuti la Sua esperienza",
    SessionRating_whatWentWrong: "Cosa è andato male?",
    SessionRating_content: "Contenuto",
    SessionRating_technology: "Tecnologia",
    SessionRating_comment: "Lasci un commento",
    SessionRating_submit: "Invia",
    SessionRating_remindMeLater: "Ricordamelo più tardi",
    SessionRating_close: "Chiudi",
    SessionRating_completed: "Finito",
    sessionRating_sessionDetails_mins: "Minuti",
    // my schedule page translations
    myschedule_availability_abty_given: "Stiamo lavorando per abbinarla ad un formatore.",
    myschedule_schedule: "Il calendario delle mie sessioni",
    myschedule_availability_needAvl:
      "Abbiamo bisogno di conoscere la Sua disponibilità per poter programmare le Sue sessioni",
    myschedule_availability_abty_not_given: "Fornire / Modificare la Sua disponibilità",
    myschedule_statusCard_completed: "Sessione completata",
    myschedule_statusCard_remaining: "Sessioni rimanenti",
    myschedule_statusCard_scheduled: "Sessioni da programmare",
    myschedule_statusCard_lost: "Sessioni perse (cancellazione tardiva o assenza)",
    myschedule_recentUpcoming_courseName: "Nome del Corso",
    myschedule_next_session: "Prossima sessione",
    myschedule_session_topic: "Argomento della sessione",
    myschedule_sessionDetails_communication: "Comunicazioni",
    myschedule_sessionDetails_allSessions: "Tutte le sessioni",
    myschedule_sessionDetails_upcomingSessions: "Prossime sessioni",
    myschedule_sessionDetails_pastSessions: "Sessioni fatte",
    myschedule_sessionDetails_teacher_name: "Formatore",
    myschedule_sessionDetails_sessions: "Numero",
    myschedule_sessionDetails_date: "Data",
    myschedule_sessionDetails_time: "Ora",
    myschedule_sessionDetails_durationText: "Durata",
    myschedule_sessionDetails_min: "Min.",
    myschedule_reschedule_Title: "Come riprogrammare una sessione",
    myschedule_reschedule_InstrBegin: "Qui è spiegato come si riprogrammano le Sue sessioni con il formatore:",
    myschedule_reschedule_instr1a: "In alto può controllare i dettagli della sessione",
    myschedule_reschedule_instr1b: "In alto può visualizzare la data e l’ora della Sua sessione.",
    myschedule_reschedule_instr2: "La disponibilità del formatore è visualizzata in verde",
    myschedule_reschedule_instr3:
      "Può vedere la disponibilità del Suo formatore. Le fasce orarie in verde corrispondono alle ore disponibili.",
    myschedule_reschedule_instr4: "Selezioni una fascia oraria per riprogrammare",
    myschedule_reschedule_instr5:
      "Per riprogrammare, clicchi sulle fasce orarie in verde a seconda dell'orario che preferisce.",
    myschedule_reschedule_next_instr1: "Non ci sono fasce orarie disponibili",
    myschedule_reschedule_next_instr2:
      "Cerchi di evitare le cancellazioni, se proprio non riesce a trovare un orario adatto con il Suo formatore, utilizzi il pulsante “Nessuna fascia oraria adatta” per cancellare la sessione. In questo caso, il suo formatore riprogrammerà questa sessione per Lei o un amministratore l’aiuterà a farlo.",
    myschedule_reschedule_next_instr3: "Cambiare il Suo formatore",
    myschedule_reschedule_next_instr4a:
      "É possibile cambiare il Suo Coach per una singola sessione o per più sessioni rimanenti. Per farlo, si prega di utilizzare il nostro",
    myschedule_reschedule_next_instr4b: "Modulo di contatto",
    myschedule_reschedule_next_instr4c:
      "e selezionare {productname} + “Cambia formatore”. Si prega di fornire una motivazione sul motivo per cui vorrebbe cambiare il Suo formatore.",
    myschedule_rechedule_next_info:
      "Per ulteriori informazioni sulle opzioni di riprogrammazione e cancellazione si prega di visitare il nostro",
    myschedule_rechedule_next_faq: "Portale FAQ.",
    myschedule_rechedule_next_noShow: "Non mostrare più questa pagina informativa",
    myschedule_rechedule_next_done: "Finito",
    myschedule_rechedule_skipButton: "Salta",
    myschedule_upcoming_joinNow: "Accedi",
    myschedule_cancel_question: "Sicuro di voler cancellare questa sessione?",
    myschedule_cancel_button: "Cancellare la sessione",
    myschedule_cancel_no: "No",
    myschedule_invalid_session: "Siamo spiacenti, questa sessione non è valida",
    myschedule_sessionDuraion_minutes: "Minuti",
    myschedule_homepage_view: "Visualizza",
    myschedule_finished_status: "Finito",
    myschedule_reschedule_button: "Riprogrammare",
    myschedule_addToCalendar_instr1: "Clicca sul",
    myschedule_addToCalendar_instr2:
      "Pulsante download per accedere al tuo calendario Learnship. Dopo averlo scaricato potrai aggiungerlo al tuo calendario personale.",
    myschedule_addToCalendar_instr3:
      "Se hai già aggiunto  un programma di Learnship al tuo calendario, assicurati di eliminare prima quello esistente.",
    myschedule_addToCalendar_instr4:
      "Scopri di più su come aggiungere il programma di Learnship al tuo calendario personale",
    myschedule_addToCalendar_instr5: "qui",
    myschedule_no_teacher_title: "Formatore non assegnato",
    myschedule_no_teacher_body:
      "Al momento non è possibile aggiungere nessuna sessione (Non è stato ancora assegnato un formatore). Si prega di contattare coach@globalenglish.com per continuare il tuo programma.",
    myschedule_no_sessions: "Nessuna sessione trovata",
    myschedule_no_upcoming_sessions: "Nessuna sessione successiva trovata",
    myschedule_no_past_sessions: "Nessuna sessione passata trovata",
    myschedule_status_lost: "Persa",
    myschedule_status_finished: "Finita",
    myschedule_status_completed: "Completata",
    myschedule_status_cancelled: "Cancellata",
    myschedule_status_inprogress: "In cours",
    myschedule_status_pending: "In sospeso",
    myschedule_status_active: "Attivo",
    myschedule_status_inplanning: "In programmazione",

    // my schedule page translations end
    // Progress page
    progress_title: "Il mio progresso",
    progress_activity_report: "Report sulle attitivà",
    progress_test_results: "Risutati dei test",
    progress_productname_sprint_skills: "Competenze aziendali di Sprint",
    progress_productname_reach_skills: "Competenze su Reach",
    progress_skill_note:
      "Deve completare il 70% o più delle sessioni e delle attività del corso  per avere diritto al cenrtificato di completamento.",
    progress_overall_card_title_prework: "Esercizi di preparazione completati",
    progress_overall_card_title_homework: "Compiti completati",
    progress_overall_card_title_session: "Sessioni completate",
    progress_overall_card_title_certificate: "Certificato",
    progress_overall_card_title_skillsCompleted: "Competenze completate",
    progress_overall_card_title_badgesEarned: "Medaglie ottenute",
    progress_overall_card_title_missionsPassed: "Missione compiuta",
    progress_overall_card_title_timeInReach: "Tempo trascorso su Reach (HH:MM)",
    progress_noSubskill: "Non ci sono sottocompetenze da mostrare.",
    progress_tab_nodata: "Non ci sono dati da mostrare.",
    progress_percentCompleted: "percentuale completata",
    progress_subskill_preworkTitle: "Pre-Lavoro",
    progress_subskill_homeworkTitle: "Compiti",
    progress_subskill_sessionTitle: "Sessione",
    progress_subskill_sessionStatusCompleted: "Completato",
    progress_subskill_sessionStatusNotCompleted: "Non completato",
    progress_subskill_sessionStatusNoSessions: "Nessuna sessione",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Tempo totale",
    progress_activity_tooltip_activitiesCompleted: "Attività completate",
    progress_activity_tooltip_reachMissionsCompleted: "Missioni completate su Reach",
    progress_activity_tooltip_timeinhhmm: "Orario in HH:MM",
    progress_activity_tabDaily: "Giornaliero",
    progress_activity_tabWeekly: "Settimanale",
    progress_activity_tabMonthly: "Mensile",
    progress_activity_tabQuarterly: "Trimestrale",
    progress_activity_tabQuarter: "Trimestre",
    progress_activity_tabYearly: "Annuale",
    progress_acitivity_Minutes: "Minuti",
    progress_acitivity_legend_selfpaced: "Tempo di apprendimento personalizzato",
    progress_acitivity_legend_trainerLed: "Tempo con la guida di un formatore",
    progress_acitivity_legend_recommended: "Consigliato",
    progress_testresults_table_testname: "Nome del Test",
    progress_testresults_table_scores: "Punteggio",
    progress_testresults_table_date: "Data",
    progress_testresults_info: "I risultati dei test verranno visualizzati entro le prossime 24 ore.",
    progress_inprogress: "In cours",
    progress_totalscore: "Punteggio totale",
    progress_placedText: "Posizionamento",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Parte",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_badge_dialog_box_title:
      "Al fine di ottenere un certificato di completamento, è necessario completare almeno il 70% degli esercizi digitali.",
    progress_badge_dialog_box_golden: "Con un punteggio di successo dell’80% si ottiene una medaglia d’oro",
    progress_badge_dialog_box_silver:
      "Con un punteggio di successo tra il 70% e il 79% si ottiene una medaglia d’argento",
    progress_badge_dialog_box_bronze:
      "Con un punteggio di successo tra il 50% e il 69% si ottiene una medaglia di bronzo",
    progerss_badge_dailog_box_digitalActivities:
      "Il punteggio di successo viene calcolato in base alla tua prestazione e all’impegno dimostrato nelle attività digitali online",
    progress_badge_dailog_box_liveSessions:
      "Il punteggio di successo viene calcolato in base alla tua prestazione e all’impegno dimostrato nelle attività digitali online e nelle sessioni live",

    //EO Progress page
    //Email Templates
    wcGroup1: "Scuse",
    wcGroup2: "Reclami",
    wcGroup3: "Complimenti",
    wcGroup4: "Congratulazioni",
    wcGroup5: "Documenti",
    wcGroup6: "Inviti",
    wcGroup7: "Domande di lavoro",
    wcGroup8: "Marketing e commerciale",
    wcGroup9: "Riunioni",
    wcGroup10: "Comunicazioni",
    wcGroup11: "Ordini",
    wcGroup12: "Informazioni sui prezzi",
    wcGroup13: "Richieste",
    wcGroup14: "Ringraziamenti",
    wcTitle11: "Scuse per ritardo in un progetto",
    wcTitle12: "Scuse per un errore contabile",
    wcTitle13: "Scuse per ritardo in una spedizione",
    wcTitle14: "Scuse per consegna di merci danneggiate",
    wcTitle15: "Scuse per assenza a una riunione",
    wcTitle21: "Reclamo generico",
    wcTitle22: "Reclamo per problema con un prodotto",
    wcTitle23: "Reclamo per addebito superiore al costo a un cliente",
    wcTitle31: "Complimenti a un collega per un progetto",
    wcTitle32: "Complimenti per il servizio di assistenza clienti",
    wcTitle33: "Complimenti per un prodotto",
    wcTitle41: "Congratulazioni per una promozione (formali)",
    wcTitle42: "Congratulazioni per una promozione (informali)",
    wcTitle43: "Congratulazioni per un evento personale",
    wcTitle51: "Documento richiesto",
    wcTitle52: "Modulo d'ordine o d'acquisto",
    wcTitle53: "Fattura",
    wcTitle61: "Invito a un evento sociale",
    wcTitle62: "Invito a un evento lavorativo",
    wcTitle63: "Accettare un invito",
    wcTitle64: "Declinare un invito",
    wcTitle65: "Annullare un evento lavorativo",
    wcTitle71: "Confermare la ricezione di una domanda",
    wcTitle81: "Annuncio di un nuovo prodotto",
    wcTitle82: "Annuncio di un nuovo rappresentante d'area",
    wcTitle83: "Demo di un nuovo prodotto",
    wcTitle84: "Cambiamento di indirizzo di fatturazione",
    wcTitle85: "Follow-Up dopo una prima riunione commerciale",
    wcTitle86: "Benvenuto a un nuovo cliente",
    wcTitle87: "Messaggio augurale agli azionisti o ai clienti",
    wcTitle91: "Proposta di orario per una riunione",
    wcTitle92: "Confermare una riunione",
    wcTitle93: "Rimandare una riunione",
    wcTitle94: "Annullare una riunione",
    wcTitle95: "Riepilogare una riunione",
    wcTitle101: "Conto sospeso",
    wcTitle102: "Richiesta di chiusura di un conto",
    wcTitle111: "Conferma d'ordine",
    wcTitle112: "Conferma di avvenuta spedizione",
    wcTitle113: "Annullare un ordine",
    wcTitle114: "Modificare un ordine",
    wcTitle115: "Confermare una consegna",
    wcTitle121: "Fornire informazioni sui prezzi",
    wcTitle122: "Accettare un preventivo",
    wcTitle123: "Rifiutare un preventivo",
    wcTitle131: "Chiedere chiarimenti sulle informazioni",
    wcTitle132: "Chiedere informazioni su un prodotto",
    wcTitle133: "Chiedere informazioni su un servizio",
    wcTitle141: "Ringraziamenti generici",
    Blob:
      "I modelli di e-mail coprono una vasta gamma di argomenti commerciali. Selezionate il modello desiderato ed esportatelo direttamente nel vostro client di posta elettronica per modificarlo.",
    OpenInEmail: "Apri in e-mail",
    Quote1: "Attualmente esistono 3,3 miliardi di account e-mail nel mondo.",
    Quote1By: "Mashable",
    Quote2: "La posta elettronica genera un profitto quasi doppio rispetto ad altri canali.",
    Quote2By: "Contatto di marketing diretto",
    Quote3: "Ogni secondo vengono inviati 3,5 milioni di e-mail.",
    Quote3By: "Contatto di marketing",
    SelectACategory: "Selezionare una categoria",
    Title: "Modelli di e-mail",
    WatchTutorial: "Guardate un tutorial video",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "Nord America",
    Cenam: "America centrale",
    SoAm: "Sud America",
    EUR: "Europa",
    ASIA: "Asia",
    CenASIA: "Asia Centrale",
    SoEASIA: "Sud Est asiatico",
    MidEAST: "Medio Oriente",
    AFR: "Africa",
    AUST: "Australia",
    Cana: "Canada",
    Mexi: "Messico",
    Uniteds: "Stati Uniti d'America",
    CostaR: "Costa Rica",
    DomRep: "Repubblica Domenicana",
    Guate: "Guatemala",
    Jama: "Giamaica",
    Panam: "Panama",
    TriniTob: "Trinidad e Tobago",
    Arge: "Argentina",
    Braz: "Brasile",
    Chil: "Cile",
    Vene: "Venezuela",
    Colomb: "Colombia",
    Peru: "Perù",
    Urug: "Uruguay",
    Austria: "Austria",
    Belg: "Belgio",
    Bulg: "Bulgaria",
    Croatia: "Croazia",
    Czec: "Repubblica Ceca",
    Denm: "Danimarca",
    Finl: "Finlandia",
    Fran: "Francia",
    Germ: "Germania",
    Greec: "Grecia",
    Hung: "Ungheria",
    Icel: "Islanda",
    Irel: "Irlanda",
    Ital: "Italia",
    Lith: "Lituania",
    Luxem: "Lussemburgo",
    Neth: "Olanda",
    Norw: "Norvegia",
    Pola: "Polonia",
    Port: "Portogallo",
    Roma: "Romania",
    Russ: "Federazione russa",
    Serb: "Serbia",
    Slovakia: "Slovacchia",
    Slovania: "Slovenia",
    Spai: "Spagna",
    Swed: "Svezia",
    Swit: "Svizzera",
    Turk: "Turchia",
    Ukra: "Ucraina",
    Unitedk: "Regno Unito",
    Chin: "Cina",
    Hong: "Hong Kong",
    Indi: "India",
    Japa: "Giappone",
    Mongo: "Mongolia",
    Pakis: "Pakistan",
    SoKore: "Corea del Sud",
    SriLan: "Sri Lanka",
    Taiw: "Taiwan",
    Afgh: "Afghanistan",
    Azer: "Azerbaigian",
    Kaza: "Kazakistan",
    Camb: "Cambogia",
    Indo: "Indonesia",
    Malay: "Malesia",
    Phil: "Filippine",
    Sing: "Singapore",
    Thai: "Tailandia",
    Viet: "Vietnam",
    Bah: "Bahrain",
    Iran: "Iran",
    Iraq: "Iraq",
    Isra: "Israele",
    Jor: "Giordania",
    Kuw: "Kuwait",
    Leb: "Libano",
    Oma: "Oman",
    Qat: "Qatar",
    SauArb: "Arabia Saudita",
    UAE: "Emirati Arabi Uniti",
    Alger: "Algeria",
    Angol: "Angola",
    Egyp: "Egitto",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenya",
    Malaw: "Malawi",
    Moroc: "Marocco",
    Mozam: "Mozambico",
    Nige: "Nigeria",
    SoAfr: "Sud Africa",
    Tanz: "Tanzania",
    Ugan: "Uganda",
    Zamb: "Zambia",
    Austra: "Australia",
    NewZea: "Nuova Zelanda",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "Acquisisca familiarità con la cultura delle regioni importanti per la Sua azienda e per la Sua vita professionale.",
    culturenotes_useculturalinfo:
      "Usi le informazioni culturali per prepararsi alle riunioni importanti con clienti e colleghi di tutto il mondo.",
    culturenotes_topicfamiliarize:
      "Familiarizzi con gli usi e i costumi di altre culture, tra cui l'orario lavorativo, cene d'affari, regali, ecc.",
    culturenotes_topiclearnculture:
      "Scopra le consuetudini, le  differenze culturali e le abitudini locali per evitare di commettere errori o gaffe culturali.",
    culturenotes_tmaworldtext:
      "I report sui vari paesi vengono sviluppati dal nostro partner TMA World e sono disponibili in versione PDF da scaricare.",
    culturenoteslocation_viewbytopic: "Visualizza per argomento",
    culturenoteslocation_viewbycountry: "Visualizza per località",
    dailyNewsFeed_resources: "Risorse",
    dailyNewsFeed_daily_News: "Notizie giornaliere con esercizi mirati",
    dailyNewsFeed_newsfeedoftheday: "Le notizie del giorno con esercizi mirati",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData:
      "Siamo spiacenti, non siamo in grado di fornire le notizie con gli esercizi, si prega di riprovare più tardi.",
    dailyNewsFeed_viewMoreCategories: "Visualizza ulteriori informazioni",
    // Email templates end
    //Error Page Translations
    error_not_found: "Oops! Pagina non trovata.",
    error_contact_csm: "Se hai bisogno di aiuto, puoi contattare il tuo Customer Success Manager.",
    error_under: "In",
    error_maintenance: "Manutenzione",
    error_under_maintenance: "Il nostro sito è attualmente in fase di manutenzione programmata.",
    error_inconvenience: "Ci dispiace per l’incoveniente",
    error_tryagain: "Si prega di riprovare più tardi.",
    error_tryagainMins: "Si prega di riprovare tra",
    error_minutes: "minuti",
    error_hours: "ore",
    error_oops: "Oops!",
    error_permission_denied: "Non sei autorizzato a vedere questa pagina",
    error_link_home: "Home page",
    error_contact_admin:
      "Se hai bisogno di aiuto, puoi contattare il tuo amministratore <donottrans> Learnship </donottrans>",
    error_sorry: "Spiacenti",
    error_load: "There was a problem loading this Page.",
    error_clear_cache: "Svuota la cache del browser, controlla la connessione Internet e riprova.",
    error_contact: "Si prega di contattare il nostro",
    error_contact_cst: "Customer support team",
    error_forhelp: "In caso avessi bisogno di aiuto",
    error_having_trouble: "Hai ancora problemi?",
    //Accents and Dialects Dropdowns
    AF: "Africa",
    AS: "Asia",
    AU: "Australia/Oceania",
    CA: "Caraibi",
    CE: "America centrale",
    EU: "Europa",
    MI: "Medio Oriente",
    NO: "America del nord",
    SO: "America del sud",
    CAMER: "Camerun",
    EGYPT: "Egitto",
    ETHIO: "Etiopia",
    GHANA: "Ghana",
    GUINE: "Guinea",
    NIGER: "Nigeria",
    SOUTH: "Sud Africa",
    TANZA: "Tanzania",
    AFGHA: "Afghanistan",
    CHINA: "Cina",
    INDIA: "India",
    INDON: "Indonesia",
    JAPAN: "Giappone",
    KAZAK: "Kazakhstan",
    LEBAN: "Libano",
    MONGO: "Mongolia",
    NORTH: "Vietnam del nord",
    PAKIS: "Pakistan",
    PHILI: "Filippine",
    SINGA: "Singapore",
    KOREA: "Corea",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwan",
    THAIL: "Thailandia",
    TURKM: "Turkmenistan",
    AUSTR: "Australia",
    FIJI_: "Fiji",
    NEW_Z: "Nuova Zelanda",
    BERMU: "Bermuda",
    CUBA_: "Cuba",
    HAITI: "Haiti",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinica (francese)",
    TRINI: "Trinidad e Tobago",
    AUSTRI: "Austria",
    BELAR: "Bielorussia",
    BELGI: "Belgio",
    BULGA: "Bulgaria",
    CYPRU: "Cipro",
    CZECH: "Repubblica Ceca",
    DENMA: "Danimarca",
    ENGLA: "Inghilterra",
    FINLA: "Finlandia",
    FRANC: "Francia",
    GEORG: "Georgia",
    GERMA: "Germania",
    GREEC: "Grecia",
    HUNGA: "Ungheria",
    IRELA: "Irlanda",
    ITALY: "Italia",
    MACED: "Macedonia del Nord",
    NETHE: "Paesi Bassi",
    NORTHI: "Irlanda del nord",
    POLAN: "Polonia",
    ROMAN: "Romania",
    RUSSI: "Federazione russa",
    SCOTL: "Scozia",
    SPAIN: "Spagna",
    SWEDE: "Svezia",
    SWITZ: "Svizzera",
    TURKE: "Turchia",
    UKRAI: "Ucraina",
    WALES: "Galles",
    IRAN_: "Iran",
    IRAQ_: "Iraq",
    ISRAE: "Israele",
    KUWAI: "Kuwait",
    SAUDI: "Arabia Saudita",
    SYRIA: "Siria",
    CANAD: "Canada",
    MEXIC: "Messico",
    ARGEN: "Argentina",
    BRAZI: "Brasile",
    CHILE: "Cile",
    COLOM: "Colombia",
    PARAG: "Paraguay",
    PERU_: "Perù",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Accenti e dialetti",
    US: "Stati Uniti d'America",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "California",
    FLORI: "Florida",
    GEORG_US: "Georgia",
    HAWAI: "Hawaii",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Louisiana",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "New Hampshire",
    NEW_J: "New Jersey",
    NEW_Y: "New York",
    NCARO: "Nord Carolina",
    NDAKO: "Nord Dakota",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pennsylvania",
    SOUTH_US: "Sud Carolina",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virginia",
    WEST_: "Virginia occidentale",
    WISCO: "Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "La tua azienda ha richiesto un resoconto mensile per il tuo manager al fine di conoscere i progressi che hai avuto con Learnship. Fornisci l'indirizzo email del tuo manager qui in basso.",
    // survey and notification
    notification_description_plural:
      "{days} di giorni che restano per completare il questionario. Deve essere completato entro {date}.",
    notification_description_singular:
      "Resta solo 1 giorno per completare il questionario. Si deve completare entro {date}.",
    notification_maintenance_message: "Halo sarà sottoposta a manuntenzione il giorno {date} alle {time}.",
    //renewal
    renewal_welcome: "Bentornati nel servizio Learnship! ",
    renewal_text:
      "La vostra licenza Learnship scade il {date}, {month} {year} Per migliorare continuamente le vostre capacità di comunicazione in inglese, rinnovate oggi stesso la licenza. Il vostro piano di studi e tutto il lavoro fatto verranno salvati e riprenderete dal livello attuale.",
    renewal_later: "Richiedimelo in seguito.",
    renewal_affirmative: "Desidero rinnovare la mia licenza.",
    renewal_negative: "Non desidero rinnovare la mia licenza.",
    renewal_yes: "SÍ",
    renewal_no: "NO",
    courselevel: "Livello del corso",
    currentunit: "Unità attuale",
    upcomingsession: "In arrivo",
    viewschedule: "View Schedule",
    currentskills: "Competenze",
    currentsubskills: "Sotto-competenze",

    // TWT translations
    twt_talk_with_teacher_title: "Talk with the Teacher",
    twt_sub_heading: "Practice your conversation skills with a teacher and other learners in our online classroom!",
    twt_instructions: "Instructions",
    twt_faq: "FAQs",
    twt_select_sessions: "Select your sessions",
    twt_view_schedule_title: "View schedule and add to calendar",
    twt_next_week: "Next week",
    twt_previous_week: "Previous week",
    twt_add_to_calendar: "Add to calendar",
    twt_view_more: "View more",
    twt_topic: "Topic",
    twt_topic_unavailable: "Topic time not available",
    twt_class_policy_title: "Parlate con l'insegnante - Politiche e Linee guida",
    twt_class_policy_subHeading:
      "Le seguenti policy e linee guida sono importanti per assicurare che la Sua esperienza con Parlate con l’Insegnante sia formativa e piacevole. La preghiamo di leggere con attenzione.",
    twt_class_policy_list01:
      "Il Suo accesso potrebbe essere limitato ad una sessione a settimana*. Le nostre classi virtuali hanno una capienza massima di 8 studenti. Consiglio: arrivi all’inizio della lezione. Le classi sono accessibili solo durante i primi 10 minuti di ogni sessione. Per esempio, una sessione che inizia alle 9:00 sarà accessibile fino alle 9:10. Dopo i primi 10 minuti, non potrà accedere alla lezione. Limitato o illimitato in base al tipo di licenza.",
    twt_class_policy_list02_sub1:
      "Quando accede alla classe, inserisca il Suo nome, città, paese e livello nel riquadro della Chat.",
    twt_class_policy_list02_sub2: `Per esempio “Il mio nome è Leo, sono di San Paulo, Brasile. Sono al livello 6”.`,
    twt_class_policy_list02_sub3: "L'istruttore attiverà quindi il microfono e apparirà l'icona del microfono.",
    twt_class_policy_list03:
      "Se ha un problema tecnico, contatti l’Assistenza Clienti. Selezioni Guida nella barra superiore della piattaforma o contatti un rappresentante dell’Assistenza utilizzando lo strumento di Chat istantanea che trova in ogni pagina Learnship One. La preghiamo di non chiedere supporto tecnico all’insegnante.",
    twt_class_policy_list04:
      "Prima di entrare in una classe in linea, guardate la Sessione di orientamento Parlate con l’insegnante che vi fornirà informazioni utili sulla partecipazione ai corsi in linea.",
    twt_class_policy_list05:
      "Se desidera ascoltare una sessione online senza parlare, Le consigliamo di farlo per una lezione. Successivamente, dovrà partecipare parlando durante la lezione. Potrà partecipare senza parlare per un Massimo di 4 lezioni a Programma. Se supera questo limite, e continua a non partecipare (parlare) alle lezioni, le sessioni termineranno.",
    twt_class_policy_list06:
      "Non saranno tollerati linguaggi osceni e offensivi in inglese o altra lingua. Se violerà questa policy, sarà immediatamente rimosso dalla sessione. Informeremo il Suo manager del Suo comportamento offensive e potremmo disattivare il Suo account.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "You have already joined this session from another device. Please logout before joining from current device.",
    twt_max_capacity_error_message:
      "Sorry you cannot join this session because it has reached maximum capacity. Please join another session",
    twt_notification_message: "There's a conversation session starting right now. Do you want to join?",

    //Vocabulary center translations
    vocab_center_product_headline: "Vocabulary center",
    vocab_center_search_word: "Search and add word",
    vocab_center_add_wordlist: "Add Word List",
    vocab_center_edit_wordlist: "Edit Word List",
    vocab_center_delete_wordlist: "Delete Word List",
    vocab_center_options_text: "Options",
    vocab_center_add_word: "Add Word",
    vocab_center_add_text: "Add",
    vocab_center_delete_wordlist_warning_message: "All the words under the list will be deleted. Click Yes to delete.",
    vocab_center_yes_text: "Yes",
    vocab_center_new_wordlist: "New Word List",
    vocab_center_created_wordlist_success_message: "You have successfully created your new word list",
    vocab_center_updated_wordlist_success_message: "You have successfully updated your word list",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "New Word",
    vocab_center_enter_word_text: "Enter a word",
    vocab_center_word_exists_in_wordlist_warning_message: "This word already exists in this Word List",
    vocab_center_save_text: "Save",
    vocab_center_new_word_message: "This word does not exist. Do you want to create your own definition for the word ?",
    vocab_center_pos_label: "Part of speech",
    vocab_center_select_wordlist_text: "Select a word list",
    vocab_center_word_label: "Word",
    vocab_center_update_wordlist: "Update word list",
    vocab_center_definition_label: "Definition",
    vocab_center_translation_label: "Translation",
    vocab_center_sentence_label: "Sentence",
    vocab_center_note_label: "Note",
    vocab_center_cancel_text: "Cancel",
    vocab_center_delete_word_text: "Delete Word",
    vocab_center_delete_word_warning_message: "Are you sure you want to delete this word from the Word List ?",
    vocab_center_note_updated_message: "Your notes updated successfully!!",
    vocab_center_close_text: "Close",
    vocab_center_no_definition_text: "No definition available",
    vocab_center_no_translation_text: "No translation available",
    vocab_center_no_sentence_text: "No sentence available",
    vocab_center_no_note_text: "No notes added",
    vocab_center_word_save_message: "You have successfully saved the word in your word List",
    vocab_center_word_exists_error_message: "Selected word already exists in the same wordlist",
    vocab_center_submit_text: "Submit",
    vocab_center_delete_text: "Delete",
    vocab_center_edit_text: "Edit",
    vocab_center_no_word_message: "Oops! There are no words in your wordlist. Add new words!",
    vocab_center_enter_wordlist_text: "Enter a word list",
    vocab_center_feature_text:
      "Without grammar, Very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",
  },
};
